export default "__VITE_ASSET__Clt_uoDF__"